import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Select,
  MenuItem,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Button,
  TableHead,
  OutlinedInput,
  TableRow,
  Paper,
  Checkbox,
  InputLabel,
  Card,
  FormControl,
  Stack,
  Chip,
  Container,
  ListItemText,
  Typography,
} from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import { useSearchParams } from "react-router-dom";
import Page from "src/components/Page";
import { debounce } from "lodash";
import Label from "src/components/Label";
import {
  getEntryAndExitTotal,
  getEntryAndExitTotalDateWise,
} from "src/api/faceRegistration";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { getURL } from "src/utils/config";
import axios from "axios";


export default function FaceRegisterListTab() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [combinedData, setCombinedData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiData, setApiData] = useState(null); 
  const [locationNames, setLocationNames] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState(null);

  const [date, setDate] = useState(dayjs());

  const tab = searchParams.get("tab") || "all";
  const queryLocation = searchParams.get("location") || "";
  const view = searchParams.get("view") || "";

  useEffect(() => {
    const fetchData = async () => {
      
      const apiUrl = getURL("employee-shifts-info/location-names?status=1");
      const AUTH_TOKEN = `${localStorage.getItem('token_type')} ${localStorage.getItem('access_token')}`;
      
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: AUTH_TOKEN,
          },
        });

        const extractedLocationNames = response.data.map(item => item.LocationName);
        setLocationNames(extractedLocationNames);
        
        setApiData(response.data);
      } catch (error) {
        console.error('Error:', error);
      }
    };
  
    fetchData();
  }, []);

  useEffect(() => {
    const locationFromURL = searchParams.get("location");
    const tabFromURL = searchParams.get("tab");
    const viewFromURL = searchParams.get("view");
    const savedLocation = localStorage.getItem("NetLocation");

    if(!locationFromURL) {
        if(savedLocation && apiData) {
          updateLocation(savedLocation,viewFromURL);
        }
    } else if(locationFromURL && apiData) {
      updateLocation(locationFromURL,viewFromURL);
    }

    if (!tabFromURL) {
      setSearchParams({ tab: "all", location: locationFromURL || "" });
    }
  }, [searchParams, apiData]);


  const handleTabChange = (event, newValue) => {
    setSearchParams({ tab: newValue, location: queryLocation});
  };

  const updateLocation = (value, view) => {
    setSelectedLocation(value);
    const selectedLocationObject = apiData.find((location) => location.LocationName === value);
    const locationId = selectedLocationObject ? selectedLocationObject.Id : 0;
    setSelectedLocationId(locationId);
    localStorage.setItem("NetLocation", value);

    if(view === "list") {
      getEntryAndExitReports(locationId);
    }

    setSearchParams({ tab, location: value });
  };

  const handleLocationChange = (value) => {
    updateLocation(value,'');
  };
  

  // const handleLocationChange = (e) => {
  //   const value = e.target.value;
  //   setDropdownValue(typeof value === "string" ? value.split(",") : value);

  //   if (value.length === 1) {
  //     const locationValue = value[0];
  //     setSearchParams({ tab, location: locationValue });
  //   } else {
  //     setSearchParams({ tab });
  //   }
  // };

  const handleSearchChange = debounce((event) => {
    setSearchTerm(event.target.value.toLowerCase());
  }, 300);

  const getFilteredDataByLocation = () => {
    if (selectedLocation === 0) return combinedData;
    return combinedData.filter((row) =>
     row.LocationName
    );
  };

  const getFilteredData1 = () => {
    return getFilteredDataByLocation().filter((row) => {
      const matchesTab =
        (tab === "entry" && row.Direction === "entry") ||
        (tab === "exit" && row.Direction === "exit") ||
        tab === "all";

      const matchesSearch = [row.Name, row.Direction, row.LocationName].some(
        (field) => field.toLowerCase().includes(searchTerm)
      );

      return matchesTab && matchesSearch;
    });
  };

  const getFilteredData = () => {
    const filteredData = getFilteredDataByLocation() || []; // Fallback to an empty array if undefined or null

    return filteredData.filter((row) => {
      const matchesTab =
        (tab === "entry" && row.Direction === "entry") ||
        (tab === "exit" && row.Direction === "exit") ||
        tab === "all";

      const matchesSearch = [row.Name, row.Direction, row.LocationName].some(
        (field) =>
          field && field.toLowerCase().includes(searchTerm.toLowerCase()) // Prevents errors when field is null or undefined
      );

      return matchesTab && matchesSearch;
    });
  };

  const handleSubmit = () => {
    getEntryAndExitReports(selectedLocationId);
  };

  const getEntryAndExitReports = (locationId) => {
    setCombinedData([]);
    const formattedDate =
      date instanceof Date
        ? date.toISOString().split("T")[0]
        : new Date(date).toISOString().split("T")[0];

    const data = {
      location_id:locationId,
      date: formattedDate,
    };

    getEntryAndExitTotalDateWise(data, (response) => {
      if (response.status === 200) {
        // console.log("entry and exit data", response.data);
        setCombinedData(response.data.combined_data);
      }
    });
  }

  const handleDateChange = (e) => {
    // console.log("handle DateChage ", e);
    setDate(e);
  };



  const handleExportExcel = async () => {
  const formattedDate =
    date instanceof Date
      ? date.toISOString().split("T")[0]
      : new Date(date).toISOString().split("T")[0];

    const formattedData = combinedData.map((item, index) => ({
      "S.No": index + 1,
      Name: item.Name || "",
      Location: item.LocationName || "",
      Time: item.FaceTime || "",
      "Preview URL": item.Snapshot || "",
      Status: item.Direction,
      Precentstatus : item.PresentStatus === 1 ? "Active":  item.PresentStatus === 0 ? "Terminated" : "InActive"
    }));

  const headers = [
    "S.No",
    "Name",
    "Location",
    "Time",
    "Preview URL",
    "Direction",
    "Present Status"
  ];

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Employee Data");

  // Define columns
  worksheet.columns = [
    { header: "S.No", key: "sno", width: 10 },
    { header: "Name", key: "name", width: 25 },
    { header: "Location", key: "location", width: 25 },
    { header: "Time", key: "time", width: 20 },
    { header: "Preview URL", key: "previewUrl", width: 40 },
    { header: "Direction", key: "status", width: 15 },
    { header: "Present Status", key: "presentStatus", width: 20 }
  ];

  // Format header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'thin' },
      right: { style: 'thin' },
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFDDDDDD' },
    };
  });

  // Add data rows
  combinedData.forEach((item, index) => {
    worksheet.addRow({
      sno: index + 1,
      name: item.Name || "",
      location: item.LocationName || "",
      time: item.FaceTime || "",
      previewUrl: item.Snapshot || "",
      status: item.Direction || "",
      presentStatus:
        item.PresentStatus === 1
          ? "Active"
          : item.PresentStatus === 0
          ? "Terminated"
          : "Inactive"
    });
  });

  // Style all rows (except header)
  worksheet.eachRow((row, rowNumber) => {
    row.eachCell((cell) => {
      cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  });

  // Export to file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `Employee_${tab}_${formattedDate}.xlsx`);
};

  return (
    <Page title="Entry and Exit Report">
    
       
        <Card>
          <TabContext value={tab}>
            <Box p={2}>
              <Paper elevation={0}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <TabList
                    onChange={handleTabChange}
                    aria-label="wrapped label tabs example"
                  >
                    <Tab
                      key="all"
                      value="all"
                      icon={
                        <Label sx={{ mr: 1 }} color="primary">
                          {getFilteredDataByLocation()?.length || 0}
                        </Label>
                      }
                      style={{ minHeight: "auto" }}
                      iconPosition="start"
                      label="All"
                    />
                    <Tab
                      key="entry"
                      value="entry"
                      label="Entry"
                      icon={
                        <Label sx={{ mr: 1 }} color="success">
                          {getFilteredDataByLocation()?.filter(
                            (d) => d.Direction === "entry"
                          ).length || 0}
                        </Label>
                      }
                      style={{ minHeight: "auto" }}
                      iconPosition="start"
                    />
                    <Tab
                      key="exit"
                      value="exit"
                      label="Exit"
                      icon={
                        <Label sx={{ mr: 1 }} color="error">
                          {getFilteredDataByLocation()?.filter(
                            (d) => d.Direction === "exit"
                          ).length || 0}
                        </Label>
                      }
                      style={{ minHeight: "auto" }}
                      iconPosition="start"
                    />
                  </TabList>

                  <Box display="flex" gap={2} alignItems="center">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date"
                        format="YYYY-MM-DD"
                        // ampm={false}
                        value={date}
                        onChange={handleDateChange}
                        slotProps={{
                          textField: {
                            size: "small",
                            style: { minWidth: 200 },
                          },
                        }}
                      />
                    </LocalizationProvider>

                    <FormControl size="small" style={{ minWidth: 200 }}>
                      <InputLabel id="select-label">Location</InputLabel>
                      <Select
                        labelId="select-label"
                        value={selectedLocation}
                        onChange={(e) => handleLocationChange(e.target.value)}
                        input={<OutlinedInput label="Select Location" />}
                      >
                        {locationNames.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleExportExcel}
                    >
                      Export
                    </Button>
                    <TextField
                      size="small"
                      placeholder="Search"
                      onChange={handleSearchChange}
                    />
                  </Box>
                </Box>
              </Paper>

              <TableContainer
                component={Paper}
                sx={{ mt: 3, maxHeight: 600, overflowY: "auto" }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>S No</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Location</TableCell>
                      <TableCell>Time</TableCell>
                      <TableCell>Preview</TableCell>
                      <TableCell>Direction</TableCell>
                      <TableCell>Present Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getFilteredData().length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7} style={{ textAlign: "center" }}>
                          No data available
                        </TableCell>
                      </TableRow>
                    ) : (
                      getFilteredData().map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.Name}</TableCell>
                          <TableCell>{row.LocationName}</TableCell>
                          <TableCell>{row.FaceTime}</TableCell>
                          <TableCell>
                            <img
                              src={row.Snapshot}
                              alt="Snapshot"
                              style={{
                                width: "100px",
                                height: "auto",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                window.open(row.Snapshot, "_blank")
                              }
                            />
                          </TableCell>

                          <TableCell>
                            <Label
                              variant="ghost"
                              color={
                                row.Direction === "entry" ? "success" : "error"
                              }
                            >
                              {row.Direction}
                            </Label>
                          </TableCell>

                          <TableCell>
                            <Label
                              variant="ghost"
                              color={
                                row.PresentStatus === 1 ? "success" : "error"
                              }
                            >
                              { row.PresentStatus === 1 ? "Active":  row.PresentStatus === 0 ? "Terminated" : "InActive"}
                            </Label>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </TabContext>
        </Card>
      
    </Page>
  );
}
